<i18n>
{
  "de": {
    "pageNotFoundTitle": "Seite nicht gefunden",
    "pageNotFoundDescription": "Es tut uns leid, aber die angefragte Seite ist nicht verfügbar."
  },
  "en": {
    "pageNotFoundTitle": "Page not found",
    "pageNotFoundDescription": "We are sorry, but the page you are trying to reach is not available."
  }
}
</i18n>

<template>
  <div class="columns">
    <div class="column is-8 is-offset-2 content">
      <div class="box">
        <h1>{{ getTitle }}</h1>
        <div v-html="$md.render(getDescription)" />
      </div>
    </div>
  </div>
</template>
<script>
import gql from 'graphql-tag'
import dotty from 'dotty'
import { cached } from '~/lib/cache'

const staticQuery = () => {
  return gql`
    query staticContent($id: ID!) {
      staticContent(
        stage: PUBLISHED,
        where: { id: $id }
      ) {
        title
        description
      }
    }
  `
}

export default {
  layout: 'static',

  data: () => ({
    title: null,
    description: null
  }),
  scrollToTop: true,

  from: null,
  to: null,

  head() {
    return {
      title: this.title
    }
  },

  computed: {
    getTitle() {
      return this.title || this.$t('pageNotFoundTitle') || ''
    },
    getDescription() {
      return this.description || this.$t('pageNotFoundDescription') || ''
    }
  },

  async asyncData({ app, route, req }) {
    const id = dotty.get(route.matched[0], 'meta.contentId')
    console.log('fetch CMS content', id)
    const { data } = await cached(
      `getStaticContentId-${id}`,
      app.apolloProvider.clients.blog.query,
      {
        query: staticQuery(),
        variables: { id }
      },
      req
    )

    return data.staticContent
  }
}
</script>
